import { gql } from "@apollo/client";

import { USER_FIELDS_FRAGMENT } from "../profile/graphql";

const GAME_FIELDS_FRAGMENT = gql`
  fragment GameFields on GameType {
    id
    awards {
      id
      category {
        source {
          sourceName
        }
      }
      displayTitle
    }
    communityRatingCount
    communityScoreBucket
    communityScorePercentages {
      percentage
      rating
    }
    gameimageSet {
      id
      imageId
    }
    isCompleted @include(if: $isUser)
    isSaved @include(if: $isUser)
    kind
    location {
      id
      company {
        id
        name
      }
      displayName
    }
    name
    overallRating @include(if: $isUser)
    primaryCategory {
      id
      name
      slug
      parent {
        id
        name
        slug
      }
    }
    slug
    userReview @include(if: $userReview) {
      id
      overallRating
    }
  }
`;

export const QUERY = gql`
  ${GAME_FIELDS_FRAGMENT}

  ${USER_FIELDS_FRAGMENT}

  query Games(
    $escapedOnly: Boolean
    $filters: GameFiltersInput
    $isSSR: Boolean!
    $isUser: Boolean!
    $page: Int
    $pageSize: Int
    $savedOnly: Boolean
    $sortBy: GameSortByOptions
    $username: String!
    $userReview: Boolean!
  ) {
    games(
      escapedOnly: $escapedOnly
      filters: $filters
      groupByLocation: false
      page: $page
      pageSize: $pageSize
      savedOnly: $savedOnly
      sortBy: $sortBy
      username: $username
    ) {
      hasNext
      objects {
        ...GameFields
      }
      page
    }
    facets: games(escapedOnly: $escapedOnly, savedOnly: $savedOnly, username: $username)
      @include(if: $isSSR) {
      facets {
        type
        items {
          id
          count
          name
          parentId
          slug
        }
      }
    }
    user(username: $username) {
      ...UserFields
    }
  }
`;
